import DownloadButton from "./DownloadButton";
import { FcDownload } from "react-icons/fc";

const displayStatus = process.env.REACT_APP_IS_EXTERNAL ? "hidden" : "hidden sm:flex"

function DownloadArea({ selectedState }) {
  return (
    <div className={`${displayStatus} bg-sky text-xs sm:text-sm rounded-sm w-full my-4 sm:my-6`}>
      <div className="p-3 sm:p-6 pt-5 sm:pt-7">
        <span className="hidden sm:inline-block pr-1">
          <FcDownload size={20} />
        </span>
        <span className="inline-block align-top">
          より詳しい集計表を確認したい方はコチラ
        </span>
      </div>
      <DownloadButton
        selectedState={selectedState}
      />
    </div>
  );
}

export default DownloadArea;
